import { Checkbox, Grid, Modal } from "@material-ui/core";
import FlexColumn from "../../../../../../components/FlexBox/FlexColumn";
import Typography from "../../../../../../components/Typography/Typography";
import { colors } from "../../../../../../styles/colors";
import { FormControlLabel, Radio, RadioGroup, withStyles } from "@material-ui/core";
import Switch from "../../../../../../components/Inputs/Switch/Switch";
import FlexRow from "../../../../../../components/FlexBox/FlexRow";
import styles from './styles.module.scss';
import TextInput from "../../../../../../components/Inputs/TextInput";
import Dropdown from "../../../../../../components/Inputs/Dropdown";
import BlueLink from "../../../../../../assets/svgComponent/BlueLink";
import ReaderLink from "../../../../../../assets/svgComponent/ReaderLink";
import BoardsLink from "../../../../../../assets/svgComponent/BoardsLink";
import { useEffect, useMemo, useState } from "react";
import SButton from "../../../../../../components/SButton/SButton";
import CreatableAutocomplete from "../../../../../../components/CreatableAutocomplete/CreatableAutocomplete";
import LeftBoardsLink from "../../../../../../assets/svgComponent/LeftBoardsLink";
import SDialog from "../../../../../../components/SDialog/SDialog";
import useIsMobile from "../../../../../../hooks/useIsMobile";

const StyledRadio = withStyles({
    root: {
        color: '#BDC7D9',
        '&$checked': {
            color: '#03BFFF',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

const BoardMapping = ({ application, noOfBoards = 4, prevChannelMapping = {}, prevFloors = [], onBack, onSave }) => {

    const width80 = useIsMobile(1635);
    const width95 = useIsMobile(962);

    const [board, setBoard] = useState(1);
    const [channelMapping, setChannelMapping] = useState(prevChannelMapping);
    const [floors, setFloors] = useState(prevFloors);


    // useEffect(() => {
    //     setChannelMapping(prevChannelMapping)
    // }, [prevChannelMapping])

    // const floors = useMemo(() => {
    //     const total = Number(noOfBoards || 0) * 16;

    //     const selectedFloors = Object.values(channelMapping).map(value => {
    //         return Number(value?.floor?.replaceAll("Floor", ""))
    //     });

    //     const floorOptions = []

    //     for (let i = 0; i < total; i++) {
    //         const floorNo = i + 1;
    //         if (!selectedFloors?.includes(floorNo)) {
    //             floorOptions.push(`Floor ${floorNo}`)
    //         }
    //     }
    //     return floorOptions
    // }, [noOfBoards, channelMapping]);

    const hChange = (channel, type, value) => {
        setChannelMapping(prev => ({
            ...prev,
            [channel]: {
                ...prev[channel],
                [type]: value
            }
        }))
    }

    const checkErrors = useMemo(() => {
        const channelMaps = Object.entries(channelMapping)
        const channels = []
        let atleaseOneChecked = false;
        for (let i = 0; i < channelMaps?.length; i++) {
            const cm = channelMaps[i];
            if (cm[1]?.checked && !atleaseOneChecked) {
                atleaseOneChecked = true
            }
            if (cm[1]?.checked && !cm[1]?.floor?.value) {
                channels.push(cm[0]?.replace("CH", ""))
            }
        }
        return {
            channels: channels,
            atleaseOneChecked: atleaseOneChecked,
            fail: channels?.length > 0 || !atleaseOneChecked
        }
    }, [channelMapping])

    return (
        <SDialog
            title={`Board and ${application} Mapping`}
            open={true}
            onClose={() => { onBack && onBack() }}
            primaryButtonConfig={{
                text: "Save",
                disabled: checkErrors?.fail,
                onClick: () => { onSave && onSave(channelMapping, floors) }
            }}
            secondaryButtonConfig={{
                text: 'Back',
                onClick: () => { onBack && onBack() }
            }}
            width={width95 ? '95%' : width80 ? "80%" : "60%"}
            isFormDialog={true}
            noteConfig={{
                text: checkErrors?.channels?.length > 0 ? `Channel ${checkErrors?.channels?.toString()} are checked, but they do not have floor named mapped to it` : '',
                color: 'var(--error-500)',
                variant: 'b4M'
            }}
        >
            <FlexColumn flexWrap="nowrap" justifyContent="start">
                <FlexRow>
                    <FlexRow flexWrap="nowarp" gap="0.5rem" width="10rem" styles={{ background: colors.grey700, padding: '0.35rem 0' }}>
                        <FlexColumn width="fit-content" gap="0.4rem" styles={{ marginTop: '1.5rem' }}>
                            <Typography variant={"b2R"} color={colors.statew1} style={{ textOrientation: 'upright', writingMode: 'vertical-lr' }} >ON</Typography>
                            <Typography variant={"b2R"} color={colors.statew1} style={{ textOrientation: 'mixed', writingMode: 'sideways-lr' }} >2D</Typography>
                        </FlexColumn>
                        <FlexColumn width="fit-content" gap="0.2rem">
                            <Typography variant={"h7R"} color={colors.statew1}>M G D H 0 4</Typography>
                            <FlexRow flexWrap="nowrap" gap="0" styles={{ marginLeft: '-1rem' }}>
                                <div style={{ display: 'inline-block', width: '1.7rem' }}>
                                    <Switch
                                        labelStyles={{ margin: '0.15rem', display: 'inline-block', transform: 'rotate(-90deg)', transformOrigin: 'center' }}
                                        checked={[0]?.includes(board)}
                                        disabled={true}
                                    />
                                </div>
                                <div style={{ display: 'inline-block', width: '1.7rem' }}>
                                    <Switch
                                        labelStyles={{ margin: '0.15rem', display: 'inline-block', transform: 'rotate(-90deg)', transformOrigin: 'center' }}
                                        checked={[4]?.includes(board)}
                                        disabled={true}
                                    />
                                </div>
                                <div style={{ display: 'inline-block', width: '1.7rem' }}>
                                    <Switch
                                        labelStyles={{ margin: '0.15rem', display: 'inline-block', transform: 'rotate(-90deg)', transformOrigin: 'center' }}
                                        checked={[2, 3]?.includes(board)}
                                        disabled={true}
                                    />
                                </div>
                                <div style={{ display: 'inline-block', width: '1.7rem' }}>
                                    <Switch
                                        labelStyles={{ margin: '0.15rem', display: 'inline-block', transform: 'rotate(-90deg)', transformOrigin: 'center' }}
                                        checked={[1, 3]?.includes(board)}
                                        disabled={true}
                                    />
                                </div>

                            </FlexRow>
                            <Typography variant={"h7R"} color={colors.statew1} style={{ letterSpacing: '6px', marginLeft: '9px' }}>1 2 3 4</Typography>
                        </FlexColumn>
                    </FlexRow>
                    <div className={styles["dip-switch-table"]}>
                        <table>
                            <thead>
                                <tr>
                                    <th colSpan={5}>DIP Switch Configurations</th>
                                </tr>
                                <tr>
                                    <th>Board</th>
                                    <th>1</th>
                                    <th>2</th>
                                    <th>3</th>
                                    <th>4</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1st Board</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>2nd Board</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>1</td>
                                    <td>0</td>
                                </tr>
                                <tr>
                                    <td>3rd Board</td>
                                    <td>0</td>
                                    <td>0</td>
                                    <td>1</td>
                                    <td>1</td>
                                </tr>
                                <tr>
                                    <td>4th Board</td>
                                    <td>0</td>
                                    <td>1</td>
                                    <td>0</td>
                                    <td>0</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </FlexRow>
                <Typography variant={"h3SB"} color={colors.brand500}>Board {board}</Typography>
                <FlexRow gap="0" styles={{ rowGap: '6rem' }}>
                    <FlexRow flexWrap="nowrap" alignItems="start" width="fit-content" className={styles["half-board-container"]}>
                        <FlexColumn flexWrap="nowrap" gap="0.2rem" width="fit-content" justifyContent="start" className={styles['floors-table-container']}>
                            <FlexRow justifyContent="space-around" gap="0.5rem" styles={{ borderBottom: `2px solid ${colors.grey300}`, paddingBottom: '1rem' }}>
                                <Typography variant={"b2B"} color={colors.grey600}></Typography>
                                <Typography variant={"b2B"} color={colors.grey600} style={{ marginRight: '2rem' }}>Floors</Typography>
                                <Typography variant={"b2B"} color={colors.grey600} style={{ marginRight: '0.5rem' }}>Channel</Typography>
                            </FlexRow>
                            {[16, 15, 14, 13, 12, 11, 10, 9]?.map(r => {
                                const channelNo = (16 * board) - (16 - r)
                                return (
                                    <FlexRow flexWrap="nowrap" gap="0.5rem" styles={{ borderBottom: `1px solid ${colors.grey300}`, paddingBottom: '0.2rem' }}>
                                        <Checkbox
                                            checked={channelMapping?.[`CH${channelNo}`]?.checked || false}
                                            onChange={() => { hChange(`CH${channelNo}`, 'checked', !channelMapping?.[`CH${channelNo}`]?.checked) }}
                                            name={`CB${channelNo}`}
                                            onlyCheckBox
                                            containerStyles={{ marginTop: '2rem', marginRight: '1rem' }}
                                            style={{ padding: 0 }}
                                            color="primary"
                                        />
                                        {/* <Dropdown
                                        placeholder="Floor"
                                        key={`F${channelNo}`}
                                        name={`F${channelNo}`}
                                        value={channelMapping?.[`CH${channelNo}`]?.floor}
                                        data={floors || []}
                                        containerStyles={{ marginTop: 0, width: '8rem' }}
                                        allowClear
                                        raisedPlaceHolder={false}
                                        disabled={!channelMapping?.[`CH${channelNo}`]?.checked}
                                        onChange={(f) => { hChange(`CH${channelNo}`, 'floor', f) }}
                                    /> */}

                                        {/* <TextInput
                                        key={`F${channelNo}`}
                                        placeholder="Floor"
                                        name={`F${channelNo}`}
                                        value={channelMapping?.[`CH${channelNo}`]?.floorName}
                                        onChange={(e) => hChange(`CH${channelNo}`, 'floorName', e?.target?.value)}
                                        raisedPlaceHolder={false}
                                        containerStyle={{ marginTop: 0 }}
                                        disabled={!channelMapping?.[`CH${channelNo}`]?.checked}
                                    /> */}

                                        <CreatableAutocomplete
                                            placeholder={application === "Elevator" ? "Floor ID" : "Locker ID"}
                                            showRaisedPlaceholder={false}
                                            options={floors || []}
                                            selectedValue={channelMapping?.[`CH${channelNo}`]?.floor}
                                            setSelectedValue={(fl) => { hChange(`CH${channelNo}`, 'floor', fl) }}
                                            setOptions={(fls) => { setFloors(fls) }}
                                            disableSelectedOption={true}
                                            disabled={!channelMapping?.[`CH${channelNo}`]?.checked}
                                            className={styles['floors-input']}
                                            containerClass={styles['floor-input-container']}
                                        />

                                        <div className={styles["channel-container"]}>
                                            <Typography style={{ whiteSpace: 'nowrap' }} variant={"b2R"} color={colors.grey400}>Channel {channelNo}</Typography>
                                        </div>

                                    </FlexRow>
                                )
                            })}
                        </FlexColumn>
                        <div className={`${styles["board-mapping"]} ${styles["bm-left"]}`}>
                            <FlexColumn gap="1rem" width="fit-content" className={styles['left-links']}>
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                            </FlexColumn>
                            <LeftBoardsLink totalBoards={noOfBoards} board={board} className={styles["left-boards-link"]} onBoardClick={(b) => { setBoard(b) }} />
                        </div>
                    </FlexRow>

                    <FlexRow flexWrap="nowrap" alignItems="start" width="fit-content" className={styles["half-board-container"]}>
                        <div className={`${styles["board-mapping"]} ${styles["bm-right"]}`}>
                            <FlexColumn gap="1rem" width="fit-content" className={styles['right-links']}>
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                                <BlueLink className={styles["blue-link"]} />
                            </FlexColumn>
                            <BoardsLink totalBoards={noOfBoards} board={board} className={styles["right-boards-link"]} onBoardClick={(b) => { setBoard(b) }} />
                        </div>
                        <FlexColumn flexWrap="nowrap" gap="0.2rem" width="fit-content" justifyContent="center" className={styles['floors-table-container']}>
                            <FlexRow justifyContent="space-around" styles={{ borderBottom: `2px solid ${colors.grey300}`, paddingBottom: '1rem' }}>
                                <Typography variant={"b2B"} color={colors.grey600} style={{ marginRight: '0.5rem' }}>Channel</Typography>
                                <Typography variant={"b2B"} color={colors.grey600} style={{ marginRight: '2rem' }}>Floors</Typography>
                                <Typography variant={"b2B"} color={colors.grey600}></Typography>
                            </FlexRow>
                            {[1, 2, 3, 4, 5, 6, 7, 8]?.map(r => {
                                const channelNo = (16 * board) - (16 - r)
                                return (
                                    <FlexRow flexWrap="nowrap" styles={{ borderBottom: `1px solid ${colors.grey300}`, paddingBottom: '0.2rem' }}>
                                        <div className={styles["channel-container"]}>
                                            <Typography style={{ whiteSpace: 'nowrap' }} variant={"b2R"} color={colors.grey400}>Channel {channelNo}</Typography>
                                        </div>
                                        {/* <Dropdown
                                        key={`F${channelNo}`}
                                        placeholder="Floor"
                                        name={`F${channelNo}`}
                                        value={channelMapping?.[`CH${channelNo}`]?.floor}
                                        data={floors || []}
                                        containerStyles={{ marginTop: 0, width: '8rem' }}
                                        allowClear
                                        raisedPlaceHolder={false}
                                        disabled={!channelMapping?.[`CH${channelNo}`]?.checked}
                                        onChange={(f) => { hChange(`CH${channelNo}`, 'floor', f) }}

                                    /> */}

                                        {/* <TextInput
                                        key={`F${channelNo}`}
                                        placeholder="Floor"
                                        name={`F${channelNo}`}
                                        value={channelMapping?.[`CH${channelNo}`]?.floorName}
                                        onChange={(e) => hChange(`CH${channelNo}`, 'floorName', e?.target?.value)}
                                        raisedPlaceHolder={false}
                                        containerStyle={{ marginTop: 0 }}
                                        disabled={!channelMapping?.[`CH${channelNo}`]?.checked}
                                    />*/}

                                        <CreatableAutocomplete
                                            placeholder={application === "Elevator" ? "Floor ID" : "Locker ID"}
                                            showRaisedPlaceholder={false}
                                            options={floors || []}
                                            selectedValue={channelMapping?.[`CH${channelNo}`]?.floor}
                                            setSelectedValue={(fl) => { hChange(`CH${channelNo}`, 'floor', fl) }}
                                            setOptions={(fls) => { setFloors(fls) }}
                                            disableSelectedOption={true}
                                            disabled={!channelMapping?.[`CH${channelNo}`]?.checked}
                                            className={styles['floors-input']}
                                            containerClass={styles['floor-input-container']}
                                        />

                                        <Checkbox
                                            checked={channelMapping?.[`CH${channelNo}`]?.checked || false}
                                            onChange={() => { hChange(`CH${channelNo}`, 'checked', !channelMapping?.[`CH${channelNo}`]?.checked) }}
                                            name={`CB${channelNo}`}
                                            style={{ padding: 0 }}
                                            color="primary"
                                        />
                                    </FlexRow>
                                )
                            })}
                        </FlexColumn>
                    </FlexRow>
                </FlexRow>
            </FlexColumn>
        </SDialog>
    )
};

export default BoardMapping;